import React from 'react'
// import './prompt-list.scss'

import { PromptTableWell } from './prompt-table-well'
import { DeliveryChannel } from '@pushly/aqe/lib/enums/delivery-channels'

type Props = {
    listType: DeliveryChannel
}

export class PromptList extends React.Component<Props> {
    public render() {
        return (
            <div className="prompt-list">
                <PromptTableWell
                    showHeader={false}
                    showSearch={false}
                    showRefresh={false}
                    listType={this.props.listType}
                />
            </div>
        )
    }
}
